/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'notes': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M18 14v-1.979A1.04 1.04 0 0 1 19.021 11H21v-.916C21 9.534 21.45 9 22 9h4c.55 0 1 .534 1 1.084V11h1.978A1.04 1.04 0 0 1 30 12.021V14c0 .55-.471 1-1.022 1h-9.957c-.55 0-1.021-.45-1.021-1zm16-1.5v23c0 .275-.225.5-.5.5h-19a.501.501 0 0 1-.5-.5v-23c0-.275.225-.5.5-.5H17v3c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3h2.5c.275 0 .5.225.5.5zm-3.503 12.997A.497.497 0 0 0 30 25H18a.497.497 0 0 0-.497.497v1.006c0 .274.222.497.497.497h12a.497.497 0 0 0 .497-.497v-1.006zm0 4A.497.497 0 0 0 30 29H18a.497.497 0 0 0-.497.497v1.006c0 .274.222.497.497.497h12a.497.497 0 0 0 .497-.497v-1.006zm0-8A.497.497 0 0 0 30 21H18a.497.497 0 0 0-.497.497v1.006c0 .274.222.497.497.497h12a.497.497 0 0 0 .497-.497v-1.006z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/notes.js